import { LineasAsientosContablesByFilterDtoIProps } from "api/DTOs/LineasAsientosContablesByFilterDto"

export const DocumentoAsociadoAsiento = ({
  handleOpenDocumentoModal,
  rowData: { numeroDocumento = "", ...props },
}: {
  handleOpenDocumentoModal: (id: string) => void
  rowData: LineasAsientosContablesByFilterDtoIProps
}) => {
  return (
    <div
      onClick={async () => {
        const idDocumento = props?.asientoContable?.facturaId

        if (!idDocumento) return
        handleOpenDocumentoModal(idDocumento)
      }}
      className={` ${
        props?.asientoContable?.facturaId
          ? "hover:tw-underline tw-text-info tw-cursor-pointer tw-text-sm tw-text-nowrap"
          : ""
      }`}
    >
      {numeroDocumento}
    </div>
  )
}

export const NombreCuentaContableAsiento = ({
  rowData: { numeroCuentaContable = "" },
}: $TSMigrationFixMe) => {
  return (
    <span className='asientos__table-option-remark'>
      {numeroCuentaContable}
    </span>
  )
}
